import { Section } from "shared/components/section.component";
import { TextLink } from "shared/components/text-link.component";

export function InfoBox() {
    return <Section title={"About"}>
        <p>I am a professional frontend engineer and indie game developer. On this page I share my projects and give you insights to my personal creation process. If you like what you see let me know and get in contact.</p>
        <p>I am especially passionated about Websites build with react and Firebase. Visit some of my projects <TextLink to="/web">here</TextLink>.</p>
        <p>The games I create include lots of different genres, lots of the games are created within game jams. Play my Games <TextLink to="/games">here</TextLink>.</p>
    </Section>
}